import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {
  getFormMessages,
  isRegistrationClosedVisible,
  isRegistrationScheduled,
  isTicketed,
  saleScheduledAndHasTickets,
} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {useEventDateInformation} from '../../../../../../../commons/hooks/dates'
import {getEventListPageUrl} from '../../../../../../../commons/selectors/environment'
import {useAppActions, useAppSelector} from '../../../../hooks/runtime'
import {getEvent} from '../../../../selectors/event'
import {
  isMemberAbleToFinishRsvp,
  isMemberRsvpExists,
  resolveButtonTextTranslation,
  resolveStatusTextTranslation,
} from '../../../../selectors/member-rsvp'
import {getTickets} from '../../../../selectors/tickets'
import {RegistrationUnavailableConfig} from './interfaces'

export const useRegistrationUnavailableConfig = (): RegistrationUnavailableConfig | null => {
  const {t} = useTranslation()

  const {changeMemberRsvp, openConfirmRsvp} = useAppActions()
  const event = useAppSelector(getEvent)
  const tickets = useAppSelector(getTickets)
  const memberRsvpExists = useAppSelector(isMemberRsvpExists)
  const eventListPageUrl = useAppSelector(getEventListPageUrl)
  const {formattedRegistrationStartDate: startDate} = useEventDateInformation(event.id)

  const messageTranslation = useAppSelector(resolveStatusTextTranslation)
  const buttonTextTranslation = useAppSelector(resolveButtonTextTranslation)
  const memberAbleToFinishRsvp = useAppSelector(isMemberAbleToFinishRsvp)

  const noTicketsAvailable = isTicketed(event) && (!tickets.length || tickets.every(saleScheduledAndHasTickets))
  const {registrationClosed, ticketsUnavailable} = getFormMessages(event)

  const editRsvp = () => {
    if (memberAbleToFinishRsvp) {
      openConfirmRsvp()
    } else {
      changeMemberRsvp(hookToAttributeSelector(DH.RSVP_INFO_BUTTON))
    }
  }

  if (isRegistrationScheduled(event)) {
    return {
      customLabel: t('registration.opensLabel', {date: startDate}),
      href: eventListPageUrl,
      messages: registrationClosed,
      dataHook: DH.CLOSED_REGISTRATION,
    }
  }

  if (noTicketsAvailable) {
    return {
      messages: ticketsUnavailable,
      href: eventListPageUrl,
      dataHook: DH.TICKETS_UNAVAILABLE,
    }
  }

  if (isRegistrationClosedVisible(event)) {
    return {
      messages: registrationClosed,
      href: eventListPageUrl,
      dataHook: DH.CLOSED_REGISTRATION,
    }
  }

  if (memberRsvpExists) {
    return {
      messages: {
        exploreEventsActionLabel: t(buttonTextTranslation),
        message: t(messageTranslation),
      },
      dataHook: DH.UPDATE_MEMBER_EVENT,
      onClick: editRsvp,
    }
  }

  return null
}
